import { useState } from 'react';
import { IS_WEB } from '@/utils/platform';

export function useOnFocus(disabled?: boolean) {
  const [isFocused, setFocused] = useState(false);

  const handleFocus = () => {
    if (IS_WEB) setFocused(disabled ? false : true);
  };

  const handleBlur = () => {
    if (IS_WEB) setFocused(false);
  };

  return {
    isFocused,
    handleFocus,
    handleBlur,
  };
}
